<customfrequention
    [mode]="mode"
    [formControl]="formControl"
>
</customfrequention>
